import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { InvoiceDocService } from '../_services';
import * as InvoiceDocActions from '../_actions/invoiceDoc';

@Injectable({
  providedIn: 'root',
})
export class InvoiceDocEffects {
  loadInvoiceDocs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InvoiceDocActions.loadInvoiceDocs),
      mergeMap(() =>
        this.invoiceDocService.getInvoiceDocs().pipe(
          map((invoiceDocs) => InvoiceDocActions.loadInvoiceDocsSuccess({ invoiceDocs })),
          catchError((error) => of(InvoiceDocActions.loadInvoiceDocsFailure({ error })))
        )
      )
    )
  );

  addInvoiceDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InvoiceDocActions.addInvoiceDoc),
      mergeMap(({ invoiceDoc }) =>
        this.invoiceDocService.saveInvoiceDoc(invoiceDoc).pipe(
          map((savedInvoiceDoc) =>
            InvoiceDocActions.addInvoiceDocSuccess({ invoiceDoc: savedInvoiceDoc })
          ),
          catchError((error) => of(InvoiceDocActions.addInvoiceDocFailure({ error })))
        )
      )
    )
  );

  updateInvoiceDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InvoiceDocActions.updateInvoiceDoc),
      mergeMap(({ invoiceDoc }) =>
        this.invoiceDocService.saveInvoiceDoc(invoiceDoc).pipe(
          map((updatedInvoiceDoc) =>
            InvoiceDocActions.updateInvoiceDocSuccess({ invoiceDoc: updatedInvoiceDoc })
          ),
          catchError((error) => of(InvoiceDocActions.updateInvoiceDocFailure({ error })))
        )
      )
    )
  );

  deleteInvoiceDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InvoiceDocActions.deleteInvoiceDoc),
      mergeMap(({ id }) =>
        this.invoiceDocService.deleteInvoiceDoc(id).pipe(
          map(() => InvoiceDocActions.deleteInvoiceDocSuccess({ id })),
          catchError((error) => of(InvoiceDocActions.deleteInvoiceDocFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private invoiceDocService: InvoiceDocService
  ) {}
}
